import React from "react";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { Breadcrumb } from "../breadcrumb/BreadCrumb.js";
import { useBreadcrumbs } from "../breadcrumb/hooks.js";
import "../breadcrumb/types.js";
import BackButton from "../breadcrumb/BackButton.js";
const useClasses = makeStyles()((theme) => ({
  workspaceHeader: {
    display: "flex",
    height: theme.custom.pageHeaderHeight,
    minHeight: theme.custom.pageHeaderHeight,
    backgroundColor: theme.palette.background.paper,
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      marginTop: theme.custom.smallSizesNavbarHeight
    },
    padding: theme.spacing(0, 4, 0)
  },
  workspaceHeaderBreadcrumbs: {
    marginLeft: theme.spacing(2)
  },
  workspaceHeaderInfo: {
    marginLeft: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    columnGap: theme.spacing(4)
  },
  workspaceHeaderInfoLeft: {
    marginLeft: theme.spacing(2)
  }
}));
function LayoutDetailsHeader({ headerInfoLeft, onBack, onBreadcrumbClick, children }) {
  const { classes } = useClasses();
  const { breadcrumbs, push, goBack } = useBreadcrumbs();
  function handleBackClick() {
    if (onBack) {
      onBack();
    } else {
      goBack();
    }
  }
  function handleBreadcrumbClick(breadcrumb) {
    if (onBreadcrumbClick) {
      onBreadcrumbClick(breadcrumb);
    } else {
      push(breadcrumb.url);
    }
  }
  return /* @__PURE__ */ React.createElement(Box, { className: classes.workspaceHeader }, /* @__PURE__ */ React.createElement(BackButton, { onBack: handleBackClick }), /* @__PURE__ */ React.createElement(Box, { className: classes.workspaceHeaderBreadcrumbs }, /* @__PURE__ */ React.createElement(Breadcrumb, { breadcrumbs, onClick: handleBreadcrumbClick })), headerInfoLeft ? /* @__PURE__ */ React.createElement("div", { className: classes.workspaceHeaderInfoLeft }, headerInfoLeft) : null, /* @__PURE__ */ React.createElement(Box, { className: classes.workspaceHeaderInfo }, children));
}
export {
  LayoutDetailsHeader
};
//# sourceMappingURL=LayoutDetailsHeader.js.map
